import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { QuizScoresStudentData } from 'teacher-ui-client/components/giraffe/charts/quiz-scores/student'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface QuizScoresStudentResponse {
  quiz_scores_events_summary: {
    data: [
      {
        category: 'average_score'
        count: Nullable<number>
      },
      {
        category: 'average_attempts'
        count: number
      },
    ]
  }
  quiz_scores_events: {
    attempts: number
    average_score: number
    lesson_number: number
  }[]
}

export async function quizScoresStudent(
  this: StudentEventsService,
  product: LegacyProductRex,
  statsScope: StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<QuizScoresStudentData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('quiz_scores_events', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<QuizScoresStudentResponse>(url, query)
  if (!data) return null

  const { quiz_scores_events_summary, quiz_scores_events } = data
  if (quiz_scores_events.length === 0) return null

  const average_score = quiz_scores_events_summary.data.find((item) => item.category === 'average_score')!.count
  const average_attempts = quiz_scores_events_summary.data.find((item) => item.category === 'average_attempts')!.count

  return {
    summary: {
      average_score,
      average_attempts,
    },
    events: [...quiz_scores_events].sort((a, b) => a.lesson_number - b.lesson_number),
  }
}
